/**
 * Geração de IDs para registros criados localmente.
 *
 * Convenção:
 *  - Mocks vão de `tt-00000001` a `tt-00000200` (gerados pelo script).
 *  - Locais começam com `tt-99XXXXXX` (timestamp + random base36).
 *  Espaço reservado evita colisão.
 */

function padUpper(s: string, len: number): string {
  return s.toUpperCase().padStart(len, '0').slice(-len);
}

export function generateRegistrationId(): string {
  const ts = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 6);
  return `tt-99${padUpper(ts + rand, 6)}`;
}

export function generateVerificationCode(id: string): string {
  const tail = id.slice(-4).toUpperCase();
  const random4 = Math.random().toString(36).slice(2, 6).toUpperCase().padEnd(4, 'X');
  return `TT-2027-${tail}-${random4}`;
}

export function generateHashFake(): string {
  const chars = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
  let out = 'Qm';
  for (let i = 0; i < 44; i++) out += chars[Math.floor(Math.random() * chars.length)];
  return out;
}

export function generateTxHashFake(): string {
  const hex = '0123456789abcdef';
  let out = '0x';
  for (let i = 0; i < 64; i++) out += hex[Math.floor(Math.random() * hex.length)];
  return out;
}

/** Wallet custodial fake derivada do email — não criptograficamente segura, só pra demo. */
export function generateMockWallet(email: string): string {
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    hash = (hash * 31 + email.charCodeAt(i)) | 0;
  }
  const hex = (hash >>> 0).toString(16).padStart(8, '0');
  return `0xtt${hex}${'a'.repeat(32)}`.slice(0, 42);
}
